module.exports = "<header _v-5ca6ee94=\"\"><a class=btn _v-5ca6ee94=\"\">back</a><h1 _v-5ca6ee94=\"\">{{name}}</h1><a href=# class=btn _v-5ca6ee94=\"\"><i class=\"fa fa-cog\" _v-5ca6ee94=\"\"></i></a></header>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5ca6ee94!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
 ** module id = 51
 ** module chunks = 0
 **/